import api from '@/api/api';
import { iniciarRequisicao, logout } from "@/helpers";
import { STATUS_HTTP } from "@/api/statusHTTP";

export const buscarProdutosFornecedorDiasEstoque = async (parametros) => {
  let url = '/dashboard/produtos-fornecedor-dias-estoque';

  const { data, status } = await api.post(url, parametros, { headers: iniciarRequisicao() }).catch(() => logout());

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.dados;
}
